import { useEffect, useState, useContext } from 'react';
import { InterfaceContext } from '../store/InterfaceProvider';
import { symbology } from '../store/StaticVariables';

const Legend = () => {
    const { activeMapAttribute, activeMeasurement, activeScale } = useContext(InterfaceContext);
    const [colors, setColors] = useState([]);

    useEffect(() => {
        setColors(symbology[activeScale][activeMapAttribute]);
    }, [activeMapAttribute, activeMeasurement, activeScale]);

    return (
        <div id="legend" aria-label="Interactive Map Legend">
            <div id={'legend-steps'}>
                {colors.map((step, i) => {
                    if (step.label === null || step.label === 'Data Unavailable') return null;
                    const border = step.color === '#ffffff' ? '1px solid #ccc' : '0';
                    return (
                        <div className={'step-box-container'} key={i}>
                            <div className={'step-box ' + step.name} style={{ backgroundColor: step.color, border }}></div>
                            <label className='label-mobile-view'>{step.label}</label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default Legend;
